import { History } from 'history';

const getNoTrlValue = (history: History): boolean => {
    try {
        const value = new URLSearchParams(history?.location?.search).get('notrl');
        return value !== null && value !== 'false';
    } catch (ignore) {} // eslint-disable-line no-empty
    return false;
};

export default getNoTrlValue;
